module.exports = __webpack_public_path__ + "img/nationalIcon.204a451d.png";